import { render, staticRenderFns } from "./DolligoFooter.vue?vue&type=template&id=c925e602&"
import script from "./DolligoFooter.vue?vue&type=script&lang=js&"
export * from "./DolligoFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports